import { nextTick } from 'vue'
import { debounce } from 'lodash-es'
import { recalculateColumnWidths } from '../column/resolve-column-auto-width'
import { syncHeaderWidthsFromDom } from '../column/sync-header-widths-from-dom'
import type { DataGrid } from '../types'

async function runColumnWidthRecalc($grid: DataGrid, containerWidth?: number) {
  recalculateColumnWidths($grid, containerWidth)
  await nextTick()
  const headerSynced = syncHeaderWidthsFromDom($grid)
  if (headerSynced) {
    await nextTick()
    syncHeaderWidthsFromDom($grid)
  }
}

export function attachGridColumnWidthMethods($grid: DataGrid) {
  $grid.recalculateColumnWidths = (containerWidth?: number) => {
    void runColumnWidthRecalc($grid, containerWidth)
  }

  $grid.scheduleColumnWidthRecalc = debounce((containerWidth?: number) => {
    void runColumnWidthRecalc($grid, containerWidth)
  }, 100)
}
